var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-copy.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6666 1.66699H8.33329C7.41413 1.66699 6.66663 2.41449 6.66663 3.33366V6.66699H3.33329C2.41413 6.66699 1.66663 7.41449 1.66663 8.33366V16.667C1.66663 17.5862 2.41413 18.3337 3.33329 18.3337H11.6666C12.5858 18.3337 13.3333 17.5862 13.3333 16.667V13.3337H16.6666C17.5858 13.3337 18.3333 12.5862 18.3333 11.667V3.33366C18.3333 2.41449 17.5858 1.66699 16.6666 1.66699ZM3.33329 16.667V8.33366H11.6666L11.6683 16.667H3.33329ZM16.6666 11.667H13.3333V8.33366C13.3333 7.41449 12.5858 6.66699 11.6666 6.66699H8.33329V3.33366H16.6666V11.667Z",
    fill: "#636D65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCopy);
export default __webpack_public_path__ + "static/media/bx-copy.2a8730c8510487e49aa05bb71c43972e.svg";
export { ForwardRef as ReactComponent };